import axios from 'axios';
import { getGlobalHandle } from '@getaccept/lib-shared-new/src/helpers';
import { CookieHelper } from '../helpers/cookie.helper';
import LocationService from '../location/location.service';
import type { GeoLocation } from '../location/types/geo-location';

export class Hubspot {
  static _hsq = getGlobalHandle()._hsq || [];
  static portalId: string = process.env.VUE_APP_HUBSPOT_PORTAL_ID;

  static initialize() {
    if (!this.portalId) {
      return;
    }
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', `//js.hs-scripts.com/${this.portalId}.js`);
    scriptTag.setAttribute('async', null);
    scriptTag.setAttribute('defer', null);
    scriptTag.setAttribute('id', 'hs-script-loader');
    scriptTag.setAttribute('type', 'text/javascript');
    document.body.append(scriptTag);
  }

  static identify(email: string) {
    if (!this.portalId) {
      return;
    }
    this._hsq.push([
      'identify',
      {
        email,
      },
    ]);
    this._hsq.push(['trackPageView']);
  }

  static trackPageView(path?: string) {
    if (!this.portalId) {
      return;
    }
    if (path) {
      this._hsq.push(['setPath', path]);
    }
    this._hsq.push(['trackPageView']);
  }

  static async signup(email: string) {
    const signupFormId: string = process.env.VUE_APP_HUBSPOT_SIGNUP_FORM_ID;
    if (!this.portalId || !signupFormId) {
      return;
    }
    const userToken = CookieHelper.getCookie('hubspotutk');
    const { ip }: GeoLocation = await LocationService.getGeoLocation();
    await axios.post(
      `https://api.hsforms.com/submissions/v3/integration/submit/${this.portalId}/${signupFormId}`,
      {
        fields: [{ name: 'email', value: email }],
        context: {
          hutk: userToken,
          pageName: document.title,
          ipAddress: ip || null,
          pageUri: window.location.href,
        },
      }
    );
  }
}
